/** @module csi/image/Browser */
define([
	"dojo/_base/declare",
	"dojo/_base/fx",
	"dojo/_base/lang",
	"dojo/aspect",
	"dojo/dom-class",
	"dojo/dom-style",
	"dojo/on",
	"dojo/query",
	"dojo/store/Memory",
	"dojo/store/Observable",
	"dojo/topic",
	"dojo/window",
	"dgrid/Grid",
	"dgrid/CellSelection",
	"dgrid/extensions/DijitRegistry",
	"underscore",
	"csi",
	"csi/_base/Deferred",
	"csi/action/NewFileControllerForImages",
	"csi/api",
	"csi/comm/GetRequest",
	"csi/config/preferences",
	"csi/core/SpecBuilder",
	"csi/def",
	"csi/def/Action",
	"csi/def/Heading",
	"csi/def/Relationship",
	"csi/def/Toolbar",
	"csi/dgrid/More",
	"csi/dgrid/SlideGrid",
	"csi/dgrid/OrderedMultiSelection",
	"csi/gallery/View",
	"csi/heading/_base",
	"csi/heading/FileSizeRenderer",
	"csi/heading/Specs",
	"csi/image/_base",
	"csi/html",
	"csi/locale",
	"csi/reflection",
	"csi/resolver",
	"csi/sessionConstants",
	"csi/state/rootStore",
	"csi/store/Nodes",
	"csi/store/Request",
	"csi/store/Values",
	"csi/toolbar/MultiFilter",
	"csi/toolbar/SortImages",
	"csi/toolbar/Tags",
	"csi/view",
	"csi/view/_QueryMixin",
	"csi/view/ToolbarPlugin",
	"csi/view/ToolbarPluginFile",
	"csi/view/ToolbarPluginRadioButton",
	"csi/view/Widget",
	"csi/widget/_DndHTML5Mixin",
	"csi/widget/Dialog",
	"csi/widget/MessageDialog",
	"csi/widget/Stateful",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/Search",
	"dojo/text!./Browser.html",

	// indirect dependencies
	"csi/heading/PropertyName",
	"csi/heading/RefTagContainer",
	"csi/heading/String",
	"csi/heading/UrlImage",
	"csi/widget/ComboBox"
], function(declare, fx, lang, aspect, domClass, domStyle, on, query, Memory, Observable, topic, winUtils, Grid, CellSelection, GridDijitRegistry, _,
	csi, Deferred, NewFileControllerForImages, api, GetRequest, configPreferences, SpecBuilder, def, Action, Heading, Relationship, Toolbar, More, SlideGrid, OrderedMultiSelection,
	GalleryView, csiHeading, FileSizeRenderer, Specs, imageBase,
	html, locale, reflection, resolver, sessionConstants, {localStore}, NodesStore, RequestStore, ValuesStore, MultiFilter, SortImages, Tags,
	csiView, _QueryMixin, ToolbarPlugin, ToolbarPluginFile, ToolbarPluginRadioButton,
	ViewWidget, _DndHTML5Mixin, Dialog, MessageDialog, Stateful, xml, Query, Search, template) {

	var LIBRARY_URL = "centric://REFLECTION/INSTANCE/ImageFolder/Image Library";
	var LIBRARY_IMAGES = "Images";
	var SORT_TOP = 45;
	const THREED_TEXTURE = "3DTexture";

	var _dialog;
	var _indexCounter = 0;
	var _storeLibrary;
	var _storeSite;
	var _storeUploads;
	var _store3DTexture;

	var _imageCacheStore = imageBase.getImageCacheStore();

	// Object: query parameters for shared folders/files
	var _sharedParams = {
		"Prv.URL": "centric://_CS_FileSystemUnmanaged",
		"X-FileVaultUnmanaged.CheckSubdirs": "true"
	};

	// Query: query parameters for shared folders/files
	var _sharedQuery;

	var _PaneItem = declare([Stateful, _QueryMixin], {
		// String: unique id for pane
		//id: "",

		// String: name displayed in UI for pane
		//name: "",

		// String: message to display in image gallery when empty
		//empty: "",

		// Number: number of images to query for at one time
		more: 50,

		// Memory: store containing child _PaneItem's
		//slideStore: null,

		/**
		 * @override
		 * Return empty context from view - the URL does not matter when used for filtering
		 */
		getContext: function(urlNode, urlParent, idRelation) {
			return _dialog.view.getContext(csi.EMPTY_URL);
		},

		_storeSetter: function(/*Store*/store) {
			// summary: automatically add querySpecStore to store
			if (store) {
				store.querySpecStore = this.querySpecStore;
			}

			this._set("store", store);
		}
	});

	var _NewFileUploadController = declare(NewFileControllerForImages, {
		/**
		 * @override
		 * Add tags to image once finished uploading
		 */
		onSecondaryPublish: function(w) {
			let tag = this.widget.browserFilter;
			var urls = this.m_response.getResultUrls();

			if (tag && urls.length) {
				w.callMethod("SiteAdmin", "UpdateImageTags")
					.addParameter("URLs", xml.ATTR_REFVECTOR, urls)
					.addParameter("TagsToAdd", xml.ATTR_STRINGVECTOR, [tag]);
			}
		}
	})

	var _TypePaneItem = declare(_PaneItem, {
		/** @property {string} imageContainerType - type of node containing images in pane */
		imageContainerType: null,

		/** @property {Memory} valuesSpecStore - memory store of specs for querying values from images and nodes containing the images */
		valuesSpecStore: null,

		getSpecValues: function(/*String*/id, /*Object*/storeOptions) {
			// summary: flip query to query by node type rather than image
			storeOptions.filterQuery = new Query().Attr2(reflection.ATTR_IMAGES, xml.OP_NOT_EQUALS, {"Dimension": 0});
			storeOptions.querySpecStore = this.valuesSpecStore;
			storeOptions.spec = this.valuesSpecStore.get(id).spec;
			storeOptions.typeNode = this.id;
			return this.inherited(arguments);
		}
	});

	var _LeftStore = declare(RequestStore, {
		idProperty: "id",

		getSlideOptions: function() {
			// summary: return options to reset sort
			return {sort: null};
		},

		getSlideStore: function(/*_PaneItem*/item) {
			return item.get("slideStore");
		},

		maySlide: function(/*_PaneItem*/item) {
			return !!item.get("slideStore");
		}
	});

	var _SharedImageStore = declare(NodesStore, {
		bExternalImages: true,

		createNodesRequest: function(/*String[]*/urls, /*Object?*/queryOptions, /*Object*/extraPaths) {
			// summary: generate request for missing urls
			var re = /^centric:/;

			urls = _.map(urls, function(url) {
				return url.replace(re, csi.EMPTY_FILE_URL);
			});

			return this.inherited(arguments, [urls, queryOptions, extraPaths]);
		},

		_onResponse: function(/*Response*/res, /*Request*/req, /*Object*/options) {
			// summary: extension point to set store data for given response
			var re = /^cf:/;

			if (!this.resultUrls) {
				this.resultUrls = _.map(res.getCompleteRefs(), function(url) {
					return url.replace(re, csi.EMPTY_URL);
				});

				this._total = res.getTotalCount();
			}

			_.each(res.getResultNodes(), function(node) {
				// fake Image node based on returned FileSystemFile node
				// Use POST request as server creates image node
				var thumb = new GetRequest("SiteAdmin", "GetImageFromFile", {
					URL: node.$URL,
					Attribute: reflection.ATTR_THUMBNAIL
				}).toRequest();

				var large = new GetRequest("SiteAdmin", "GetImageFromFile", {
					URL: node.$URL,
					Attribute: reflection.ATTR_VIEWABLE
				}).toRequest();

				xml.nodeCreateClientAttr(node, reflection.ATTR_THUMBNAIL, xml.ATTR_URL, thumb);
				xml.nodeCreateClientAttr(node, reflection.ATTR_MEDIUM_IMAGE, xml.ATTR_URL, large);
				xml.nodeCreateClientAttr(node, reflection.ATTR_VIEWABLE, xml.ATTR_URL, large);
				xml.nodeCreateClientAttr(node, reflection.ATTR_TAGS, xml.ATTR_STRINGVECTOR, []);

				node.$Type = node[xml.ATTR_TYPE] = reflection.TYPE_IMAGE;
				node.$URL = node.$URL.replace(re, csi.EMPTY_URL);
				this.put(node);
			}, this);
		}
	});

	var _SharedFolderStore = declare(_LeftStore, {
		specStore: null,
		urlFolder: null,

		constructor: function(/*Object*/options) {
			this.request = new Search()
				.setLimitAttribute(this.urlFolder, "Folders")
				.getRequest()
				.mixinParameters(_sharedParams);
		},

		getSlideStore: function(/*_PaneItem*/item) {
			// summary: create store to display child folders
			// FIX: should we just pre-allocate the store for those that have folders and just use the slideStore attribute rather than a function?
			var store = item.get("slideStore");
			if (!store) {
				store = new _SharedFolderStore({
					specStore: this.specStore,
					urlFolder: item.get("id")
				});
				item.set("slideStore", store);
			}

			return store;
		},

		maySlide: function(/*_PaneItem*/item) {
			// summary: return true if item has folders
			return item.get("hasFolders");
		},

		_onResponse: function(/*Response*/res, /*Request*/req, /*Object*/options) {
			// summary: map each folder node into _PaneItem
			var data = _.map(res.getResultNodes(), function(node) {
				return new _PaneItem({
					id: node.$URL,
					name: node.$Name,
					hasFolders: !!node.Folders.length,
					querySpecStore: this.specStore,
					store: _getSharedImageStore(node.$URL)
				});
			}, this);

			this._setData(data);
		}
	});

	var _GridRight = declare([Grid, More, OrderedMultiSelection, GridDijitRegistry], {
		allowSelectAll: true,
		maintainOddEven: false,

		selectAll: function() {
			// summary: do not select all if in single selection mode
			if (this.get("selectionMode") != "single") {
				this.inherited(arguments);
			}
		},

		_initSelectionEvents: function() {
			// summary: listen for mouseup on grid content
			this.inherited(arguments);
			on(this.contentNode, "mouseup", lang.hitch(this, this._onMouseUpContent));
		},

		_onMouseUpContent: function(event) {
			// summary: deselect all if do not click item
			if (!event.shiftKey && !event.ctrlKey && !event.metaKey && (event.target == event.currentTarget)) {
				this.clearSelection();
			}
		}
	});

	var _FilterPlugin = declare([MultiFilter, ToolbarPlugin], {
		// only use new template to remove icon for reset filter button
		postCreate: function() {
			// summary: add hooks into view
			this.inherited(arguments);
			this.createFilterContainer(this.actionToolbar.domNode);
			this.own(aspect.after(this.getView(), "onSelectPane", lang.hitch(this, this._onSelectPane), true));
		},

		_onSelectPane: function(/*_PaneItem*/item) {
			// summary: when switching panes need to reset the queryMixin (mixed into item) used for filtering
			var view = this.getView();
			this.set("queryMixin", item);

			view.selectDefaultFilter(item.id, this);
		},

		_updateValueNode: function(/*Object*/params, /*_Widget*/w) {
			// summary: image browser filters do not support counts fully, so removing them (see DE23970)
			if (params && params.store) {
				params.labelAttr = params.store.labelProperty;

				// if filter is required to display items then redefine default clear text to none.
				if (this.queryMixin.store.bQueryRequired) {
					params.defaultClearText = "SelectNone";
				}
			}

			this.inherited(arguments);
		}
	});

	var _SortImagesPlugin = declare([SortImages, ToolbarPlugin], {
		postCreate: function() {
			const defaultKey = localStore.imageSort || imageBase.SORT_SORTDATENEWEST;
			this.defaultValue = locale.resource(defaultKey);
			this.inherited(arguments);
			const data = imageBase.imageSortingData.map((obj) => ({
				name: locale.resource(obj.key),
				...obj
			}));

			this.set("store", new Memory({
				idProperty: "key",
				data,
			}));
		}
	});

	var _TagsPlugin = declare([Tags, ToolbarPlugin], {
		postCreate: function() {
			// summary: set store for Tags ComboBox
			this.inherited(arguments);

			var q = new Query();
			q.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, reflection.URL_INSTANCE + reflection.TYPE_TAGSPEC + "/Image/Tags");

			this.set("store", new ValuesStore({
				filterQuery: q,
				typeNode: reflection.TYPE_TAG,
				requestParameters: {
					"Qry.Value.Node": "Name"
				}
			}));
			this.own(aspect.after(this.getView(), "_onRefresh", lang.hitch(this, this._onRefresh), true));
		},

		_onRefresh: function() {
			var store = this.get("store");
			if (store && store.reset) {
				store.reset();
				store.query();
			}
		},

		_setDisabledAttr: function(/*Boolean*/b) {
			// summary: update store and value based on current selections
			this.set("selection", this.getView().getSelectedImages());

			this.inherited(arguments);
		}
	});

	var _ToolbarPluginOneFile = declare(ToolbarPluginFile, {
		multiple: false,

		postMixInProperties: function() {
			// summary: override action name - id is only different to distinguish it from multi-file upload
			this.defAction.m_name = locale.resource("Upload");
			this.inherited(arguments);
		}
	});

	function _getSharedImageStore(/*String*/urlFolder) {
		// summary: if cachingStore specified, then use that for storage of items
		if (!_sharedQuery) {
			_sharedQuery = new Query();
			_sharedQuery.Or()
				.Node(xml.PROP_NAME, xml.OP_MATCHES, "%.jpg")
				.Node(xml.PROP_NAME, xml.OP_MATCHES, "%.gif")
				.Node(xml.PROP_NAME, xml.OP_MATCHES, "%.png")
				.Node(xml.PROP_NAME, xml.OP_MATCHES, "%.bmp");
		}

		return new _SharedImageStore({
			cachingStore: _imageCacheStore,
			filterQuery: _sharedQuery,
			requestParameters: lang.mixin({
				"Qry.Limit.Path": xml.getUrlPath(urlFolder, xml.path("Files")),
				"Ext.File.Info": true
			}, _sharedParams)
		});
	}

	var _Browser = declare([ViewWidget, _DndHTML5Mixin], {
		bPopup: true,
		imageSize: reflection.IMAGE_SIZE_SMALL,
		templateString: template,

		/** @property {boolean} bShow3D - shows the 3D image selection on left grid */
		bShow3D: false,

		/** @property {string} browserFilter - default browser filter if any */
		browserFilter: null,

		// Node: context for Item pane
		//nodeContext: null,

		// String: selection mode for images ("single" vs "extended")
		selectionMode: "extended",

		// String: to set the image count to above 20 if its a new upload
		_widgetAction: null,

		sortPlugin: null,

		// Store: store of selected images
		//storeSelected: null,

		// Boolean: force action buttons to be visible if true
		//bAllowSelection: false,

		// Boolean: indicates if there is a context node
		//_bItemContext: false,

		// Grid: grid widget for navigation
		//_gridLeft: null,

		// Grid: grid widget to display images
		//_gridRight: null,

		// Spec: spec for name of image
		//_imageNameSpec: null,

		// Spec: spec for name of node containing image
		//_nodeNameSpec: null,

		// _PaneItem: selected item in left pane
		//_paneItem: null,

		// Object: object containing pinned ids
		//_pins: null,

		// Object: object containing ids to select next time they are drawn
		//_preselect: null,

		// Store: store of available panes appearing on left
		//_storeLeft: null,

		// Spec: spec used to render thumbnail
		//_thumbnailSpec: null,

		addPane: function(/*String*/id, /*_PaneItem*/item) {
			// summary: set query handler for panes with relationships feeding the data store
			item.set("id", id);

			if (!item.get("name")) {
				item.set("name", locale.resource("ImageBrowser" + id));
			}

			if (!item.get("empty")) {
				item.set("empty", locale.resourceIfExists("ImageBrowser" + id + "_Empty"));
			}

			this._storeLeft.add(item);
		},

		buildRendering: function() {
			this.inherited(arguments);

			// create navigation pane
			this._gridLeft = new (declare([SlideGrid, CellSelection, GridDijitRegistry]))({
				maintainOddEven: false,
				selectionMode: "single",
				showHeader: false,
				slideInTitle: locale.resource("SlideIn"),
				slideOutTitle: locale.resource("SlideOut"),
				slideOutRootTitle: locale.resource("SlideOut_Top"),
				store: this._storeLeft,
				columns: [
					{field: "name"}
				],
				renderRow: function(object, options) {
					var row = this.inherited(arguments);
					row.className = this["class"] + object.id;
					return row;
				}
			}, this.leftNode);

			this._gridLeft.on("dgrid-select", lang.hitch(this, this._onLeftSelect));

			// define column cells for list view
			var columns = {
				Images: {
					label: locale.resource("Image"),
					renderCell: lang.hitch(this, this._renderRowImage),
					sortable: false
				},
				File: {
					label: locale.resource("File"),
					renderCell: lang.hitch(this, this._renderCellName)
				},
				FileSize: {
					label: locale.resource("Size"),
					renderCell: lang.hitch(this, this._renderCellImageSize)
				},
				DateAdded: {
					label: locale.resource("DateAdded"),
					renderCell: lang.hitch(this, this._renderCellDateAdded)
				}
			};

			// create image gallery
			this._gridRight = new _GridRight({
				loadingMessage: locale.resource("LoadingEllipsis"),
				moreLabel: locale.resource("ViewQueryMore"),
				renderRow: lang.hitch(this, this._renderRowImage),
				columns: columns,
				showHeader: false,
				sort: [{attribute: "DateAdded", descending: true}]
			}, this.headingsNode);

			this._gridRight.on("dgrid-select", lang.hitch(this, this._onRightSelect));
			this._gridRight.on("dgrid-deselect", lang.hitch(this, this._onRightDeselect));
			this._gridRight.on("dgrid-sort", lang.hitch(this, this._setGallerySortOption));

			// make sure that parameters includes selectionMode so that _setSelectionModeAttr logic will be applied
			this.params.selectionMode = this.selectionMode;
		},

		getHeadingSpec: function(/*String|Key*/key, /*Boolean*/bAdd) {
			// summary: return spec given query key or data point key
			return this._specs.getByQueryKey(key) || this.inherited(arguments);
		},

		getSelectedImageUrls: function() {
			// summary: return currently selected image urls
			return _.keys(this._gridRight.selection);
		},

		getSelectedImages: function() {
			// summary: return currently selected images
			return _.map(this.getSelectedImageUrls(), function(url) {
				return this.get(url);
			}, this._gridRight.store);
		},

		isViewingSelections: function() {
			// summary: return true if viewing list of selected items
			return this._gridRight.store == this.storeSelected;
		},

		loadPlugins: function() {
			// summary: toolbar is loaded after attributes are applied, so _setSelectionModeAttr could not affect
			// toolbar; so appliy visibility to toolbar now that toolbar is created
			var dfd = this.inherited(arguments);
			this._updateVisibility();
			return dfd;
		},

		onContext: function(/*Context*/ctx) {
			// summary: clicking is reserved for selecting images
			ctx.bReserveClick = true;
			this.inherited(arguments);
		},

		onSelectPane: function(/*_PaneItem*/item) {
			// summary: extension point called when left pane is selected
			this._widgetAction = null;
		},

		onViewStart: function(/*Deferred[]*/dfds) {
			// summary: change location of tooltip to bottom
			this.tooltipView.position = ["below-centered", "above-centered"];
			this.inherited(arguments);
		},

		/**
		 * Set 3D Filters if image browser opened from 3dBrowser
		 */
		preActionSetNode: function() {
			if (this.bShow3D) {
				this._gridLeft.clearSelection();
				this._gridLeft.selection[THREED_TEXTURE] = {0: true};
			} else if (this._gridLeft.selection[THREED_TEXTURE]) {
				this._gridLeft.clearSelection();
			}
		},

		postMixInProperties: function() {
			// summary: initialize members and globals
			const removedPanes = api.getRemovedImagePanes();

			this.inherited(arguments);
			this.plugins = [];
			this._pins = {};
			this._preselects = {};

			// convert heading to Spec
			const ctx = this.getContext();
			const specBuilder = new SpecBuilder(reflection.TYPE_IMAGE, ctx, null, null, null, this.defView.m_headings);
			const {configuredSpecs, getSpecForHeading} = specBuilder;

			// create store for query filters
			const specTags = configuredSpecs[1];
			const specFile = configuredSpecs[2];
			const specName = configuredSpecs[3];
			const specDate = configuredSpecs[4];
			const specFileSize = configuredSpecs[5];
			const sortedIndex = configuredSpecs[6];

			// track heading used to render images
			this._thumbnailSpec = configuredSpecs[0];
			this._imageNameSpec = specFile;
			this._dateSpec = specDate;
			this._fileSizeSpec = specFileSize;

			// track spec for node name whose typed path needs to change per type for performance
			this._nodeNameSpec = specName;

			// disable filtering for date, size, and internal index attributes
			specDate.canFilter = _.noop;
			specFileSize.canFilter = _.noop;
			sortedIndex.canFilter = _.noop;

			// make sure to do all for type store first so each spec has a unique sid
			let specs = this._specs = new Specs();
			specs.add(specName);
			specs.add(specTags);
			specs.add(specFile);
			specs.add(specFileSize);
			specs.add(specDate);
			const typeSpecStore = specs.getQueryStore();

			// values store for types flips query to be of type rather than image, so need to flip spec paths as well
			specs = new Specs();
			specs.add(getSpecForHeading(specName.heading));
			specs.add(getSpecForHeading(specTags.heading));
			specs.add(getSpecForHeading(specFile.heading));

			specs.traverse(false, function(c) {
				if (c.querySpec) {
					if (c.heading.m_id == reflection.ATTR_TAGS) {
						c.querySpec.path = "Child:Images(Image)/Child:Tags(Tag)";
					} else {
						c.querySpec.path = c.querySpec.path ? null : "Child:Images";
					}
				}
			});

			var typeValuesSpecStore = specs.getQueryStore();

			// create specs for searching shared directory of images
			specs = new Specs();
			specs.add(specFile);
			var fileSpecStore = specs.getQueryStore();

			// create specs for searching other image panes
			specs = new Specs();
			specs.add(specTags);
			specs.add(specFile);
			specs.add(specDate);
			specs.add(specFileSize);
			specs.add(sortedIndex);
			var imageSpecStore = specs.getQueryStore();

			function getSiteStore() {
				return new NodesStore({
					bQueryRequired: true,
					cachingStore: _imageCacheStore,
					filterQuery: new Query()
						.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, csi.EMPTY_URL)
						.Attr("IgnoreInSearch", xml.OP_EQUALS, false)
						.Access(xml.RIGHT_READ, "Parent:Images"),
					sortQuery: new Query().SortByNode(xml.PROP_NAME),
					typeNode: reflection.TYPE_IMAGE
				});
			}

			// setup global stores
			_storeLibrary = _storeLibrary || Observable(new NodesStore({
				bAddToFront: true,
				cachingStore: _imageCacheStore,
				nodeUrl: LIBRARY_URL,
				nodeAttribute: LIBRARY_IMAGES,
				requestParameters: {
					"Qry.Limit.Path": xml.getUrlPath(LIBRARY_URL, xml.path(LIBRARY_IMAGES)),
					"Ext.File.Info": true
				},
				typeNode: reflection.TYPE_IMAGE
			}));

			_storeUploads = _storeUploads || Observable(imageBase.getUploadsStore(localStore.imageSort));

			// create data store for left pane
			this._storeLeft = new _LeftStore();

			// add required panes to left side
			this.addPane("Item", new _PaneItem({querySpecStore: imageSpecStore}));
			this.addPane("Library", new _PaneItem({querySpecStore: imageSpecStore, store: _storeLibrary}));

			// add pane showing all images on Site if not removed as part of configuration
			if (_.indexOf(removedPanes, "Site") < 0) {
				_storeSite = _storeSite || getSiteStore();

				this.addPane("Site", new _PaneItem({querySpecStore: imageSpecStore, store: _storeSite}));
			}

			// add types pane if so configured
			if (_.indexOf(removedPanes, "Type") < 0) {
				var typeData = csi.transform(api.getImageTypes(), function(type) {
					// create _PaneItem for type; use typed path in store to provide hint to DB to speed up query
					var rc = reflection.getClass(type);
					if (!rc || !rc.isDerivedFrom("ImageContainer")) {
						return null;
					}

					return new _TypePaneItem({
						id: type,
						imageContainerType: type,
						name: locale.type(type),
						empty: locale.resource("ImageBrowserSite_Empty"),
						querySpecStore: typeSpecStore,
						valuesSpecStore: typeValuesSpecStore,
						store: new NodesStore({
							bQueryRequired: true,
							cachingStore: _imageCacheStore,
							filterQuery: new Query().Node(xml.PROP_TYPE, xml.OP_EQUALS, type, `(Image)Parent:Images(${type})`),
							typeNode: reflection.TYPE_IMAGE
						})
					});
				});

				if (typeData) {
					this.addPane("Type", new _PaneItem({
						slideStore: new Memory({
							data: csi.sort(typeData, "name"),
							labelProperty: "name"
						})
					}));
				}
			}

			// add shared directories
			var folder = resolver.resolveNode(reflection.URL_FILESYSTEM_ROOT, true);
			var shared = resolver.m_cache.getChildren(folder, "Folders", true);

			_.each(shared, function(snode) {
				this.addPane("Shared" + snode.$URL, new _PaneItem({
					name: snode.$Name,
					querySpecStore: fileSpecStore,
					slideStore: new _SharedFolderStore({specStore: fileSpecStore, urlFolder: snode.$URL}),
					store: _getSharedImageStore(snode.$URL)
				}));
			}, this);

			this.addPane("Uploads", new _PaneItem({
				queryOptions: {
					// set sort function so that Observable store inserts new uploads at proper index - by default it will add to end if no sorting specified
					sort: function(a, b) {
						return (_storeUploads.getResultIndex(a) < _storeUploads.getResultIndex(b)) ? -1 : 1;
					}
				},
				querySpecStore: imageSpecStore,
				store: _storeUploads
			}));

			this.addPane("Selected", new _PaneItem({
				store: this.storeSelected,
				more: 1000
			}));

			_store3DTexture = _store3DTexture || getSiteStore();
			this.addPane(THREED_TEXTURE, new _PaneItem({querySpecStore: imageSpecStore, store: _store3DTexture}));
		},

		/**
		 * @override
		 * Refresh browser when images need to be redrawn
		 */
		redrawImages(imageUrls) {
			this._onRefresh();
		},

		resetSelections: function() {
			// summary: clear all selections including those that are pinned
			var pinned = _.keys(this._pins);
			this._pins = {};
			this._gridRight.clearSelection();
			_.each(pinned, this.storeSelected.remove, this.storeSelected);
			query(".iconImgPin", this._gridRight.domNode).orphan();
		},

		selectFirstPane: function(/*Boolean*/bOnlyIfNoSelection) {
			// summary: select Item pane unless no node context, otherwise Library
			if (this._is3DGridSelected()) {
				this.selectPane(THREED_TEXTURE, true);
			} else if (!bOnlyIfNoSelection || _.isEmpty(this._gridLeft.selection)) {
				if (sessionConstants.isLocalUser) {
					this.selectPane("Uploads", true);
				} else {
					var item = this._storeLeft.get("Item");
					var store = item.get("store");
					this.selectPane(store ? "Item" : "Library", true);
				}
			}
		},

		/**
		 * Set tab tag filter based on 3d viewer selections
		 * @param {string} id
		 * @param {object} filter
		 */
		selectDefaultFilter: function(id, filter) {
			if (id == THREED_TEXTURE) {
				filter._changeFilter(xml.queryKey("Node Name", null, "Child:Tags"), [this.browserFilter]);
			}
		},

		selectPane: function(/*String*/id, /*Boolean*/bForce) {
			// summary: select pane for item
			var grid = this._gridLeft;
			var cell = grid.cell(id, "0");
			if (!cell.element) {
				// if not on top level, then slide to top and select pane when done
				var selection = {};
				selection[id] = {0: true};
				grid.clearSelection();
				grid.slideToTop(selection);
			} else if (bForce || !grid.isSelected(cell)) {
				// on top level, so just select desired pane
				grid.clearSelection();
				grid.select(cell);
			}
		},

		startup: function() {
			// summary: startup grids too
			var dfd = this.inherited(arguments);
			this._gridLeft.startup();
			this._gridRight.startup();
			return dfd;
		},

		_canAddToLibrary: function(/*Context*/ctx, /*Action*/action) {
			// summary: can add to library if there are selections and are not already in the library pane
			return !_.isEmpty(this._gridRight.selection) && (this._gridRight.store != _storeLibrary);
		},

		_canDelete: function(/*Context*/ctx, /*Action*/action) {
			// summary: only allow deleting images if in Uploads pane, or when managing images in Library pane
			return !_.isEmpty(this._gridRight.selection) &&
				((this._gridRight.store == _storeUploads) || (!this.nodeContext && (this._gridRight.store == _storeLibrary)));
		},

		_canRefresh: function(/*Context*/ctx, /*Action*/action) {
			// summary: allow refresh if store support reset function
			// NOTE: although slideStore is mentioned here, the stores used for it do not support reset API
			var item = this._paneItem;
			var store = item && item.get("store");
			var slideStore = item && item.get("slideStore");
			return (store && store.reset) || (slideStore && slideStore.reset);
		},

		_canPin: function(/*Context*/ctx, /*Action*/action) {
			// summary: can pin if there is at least one unpinned selection
			return !this.isViewingSelections() && _.some(this._gridRight.selection, function(id) {return !this._pins[id];}, this);
		},

		_canUnpin: function(/*Context*/ctx, /*Action*/action) {
			// summary: can unpin if there are pinned images
			return !_.isEmpty(this._pins);
		},

		_canTag: function(/*Context*/ctx, /*Action*/action) {
			// summary: only allow tagging of images stored within C8 file vault
			return !_.isEmpty(this._gridRight.selection) && !this._gridRight.store.bExternalImages;
		},

		/**
		 * On HTML5 image drop and paste
		 * @param {File[]) files
		 */
		_onDropImage: function(files) {
			var p = this.getPlugin("Upload");
			if (p) {
				p._files = files;
				p.onChange(files);
			}
		},

		_onLeftSelect: function(event) {
			// summary: set store for selected item
			if (!html.exists(this)) {
				return;
			}

			var dfd = new Deferred();
			var item = this._paneItem = event.cells[0].row.data;
			var grid = this._gridRight;
			var self = this;
			var action = this._widgetAction;
			var store = item.get("store");

			grid.clearSelection();

			// update node name spec based on type selected to improve performance of query
			if (item.imageContainerType) {
				this._nodeNameSpec.querySpec.path = `(Image)Parent:Images(${item.imageContainerType})`;
			}

			// call now to update pane visibility
			this._updateVisibility();

			//add class to selected root item so it can be styled
			$(this.leftNode).find('.dgrid-row').removeClass("csi-browser-left-item-selected");
			$(this.leftNode).find('.ui-state-active').closest('.dgrid-row').addClass("csi-browser-left-item-selected");

			fx.fadeOut({
				node: grid.contentNode,
				onEnd: function() {
					// notify the new pane that is selected to make sure item is fully initialized
					self.onSelectPane(item);

					// make sure that when you upload more than 20 items that you see them all when done
					if (store) {
						var n = item.get("more") || 20;

						if ((action == "upload") && store.getTotal) {
							n = Math.max(n, store.getTotal() || 0);
						}

						grid.set("moreRows", n);
					}

					// update right grid with properties of new pane
					grid.set("noDataMessage", item.get("empty") || locale.resource("SEARCH_NO_RESULTS"));
					grid.set("store", store, item.get("query") || {}, item.get("queryOptions") || {});

					self.toolbarNode.enablePlugins();
					self._setSortPos();

					fx.fadeIn({node: this.node}).play();
					dfd.resolve();
				}
			}).play();

			this.sortPlugin = this.toolbarNode.getPlugin("SortImages");

			return dfd;
		},

		_onRightSelect: function(event) {
			// summary: add selected rows to selected store
			if (!html.exists(this)) {
				return;
			}

			if (!this.isViewingSelections()) {
				_.each(event.rows, function(r) {
					if (!this._pins[r.id]) {
						this.storeSelected.put(r.data);
					}
				}, this);

			}

			this.toolbarNode.enablePlugins();
		},

		_onRightDeselect: function(event) {
			// summary: remove selected rows from selected store if not pinned
			if (!html.exists(this)) {
				return;
			}

			if (!this.isViewingSelections()) {
				_.each(event.rows, function(r) {
					if (!this._pins[r.id]) {
						this.storeSelected.remove(r.id);
					}
				}, this);
			}

			this.toolbarNode.enablePlugins();
		},

		_preUpload: function(/*Controller*/ac) {
			// summary: indicate that uploaded files need to be wrapped with image nodes
			ac.typeNode = reflection.TYPE_IMAGE;
			ac.prepend = true;
			return true;
		},

		_onUpload: function(/*Controller*/ac) {
			// summary: add new images to upload store and switch to that pane
			this._widgetAction = 'upload';
			this._gridRight.clearSelection();
			var uploadNodes = ac.getNewFileNodes();

			if (this._is3DGridSelected()) {
				if (_.isEmpty(uploadNodes) && ac.m_response) {
					uploadNodes = ac.m_response.getNodes();
				}
				this.selectPane(THREED_TEXTURE, true);
			} else {
				this.selectPane("Uploads");
			}


			_.each(uploadNodes.reverse(), function(node, i) {
				this._preselects[node.$URL] = true;
				node.sortedIndex = ++_indexCounter;
				_storeUploads.add(node);
			}, this);

			var sortAttr = [{attribute: "sortedIndex", descending: true}];
			var gridSort = this._gridRight._getSort();

			if (_.isArray(gridSort) && gridSort.length) {
				sortAttr.push(gridSort[gridSort.length - 1]);
				this._gridRight.set("sort", sortAttr);
			}

			this.syncImageStores(uploadNodes);
		},

		_onRefresh: function(/*Controller*/ac) {
			// summary: refresh store on right and query value stores
			var item = this._paneItem;
			var slideStore = item.get("slideStore");
			var bIgnoreGrid = false;

			item.onChangeData();

			if (slideStore && slideStore.reset) {
				slideStore.reset();
			}

			var gridSort = this._gridRight._getSort();
			if (_.isArray(gridSort) && gridSort.length > 1) {
				// reset grid sort to prevent sorting by newly added items
				this._gridRight.set("sort", [gridSort[1]]);
				bIgnoreGrid = true;
			}

			this.resetStore(bIgnoreGrid);
		},

		_is3DGridSelected: function() {
			return this._gridLeft.selection && (_.keys(this._gridLeft.selection)[0] == THREED_TEXTURE);
		},

		resetStore: function(/*Boolean?*/bIgnoreGrid) {
			var store = this._paneItem.get("store");

			if (store && store.reset) {
				store.reset();
				if (!bIgnoreGrid) {
					this._gridRight.refresh();
				}
			}
		},

		syncImageStores: function(nodes) {
			// summary: trigger refresh for canvas myuploads store
			_.delay(function() {
				// delay by 1 second to wait for grid to refresh and update the parent store
				topic.publish("/csi/image/browser/update", nodes);
			}, 1000);
		},

		/**
		 * Activate / Deactivate HTML5 dnd event handling on show/hide browser dialog
		 * @param {boolean} bActive
		 */
		toggleDnD: function(bActive) {
			this.dndHTML5Toggle(bActive, this.headingsNode, this._onDropImage, null, true, true);
		},

		_onFilter: function(/*Controller*/ac) {
			// summary: apply filter to _gridRight store
			this._gridRight.set("query", ac.actionValue);
			this._setSortPos();
		},

		_onSortImages: function(/*Controller*/ac) {
			this._gridRight.set("sort", [ac.actionValue[0]]);
		},

		_onPin: function(/*Controller*/ac) {
			// summary: pin current selections (set pin attribute on item)
			var grid = this._gridRight;

			_.each(this.getSelectedImages(), function(image) {
				var id = image.$URL;
				if (!this._pins[id]) {
					this._pins[id] = true;
					this.storeSelected.put(image);
					html.create("div", {"class": "csiActionIcon iconImgPin"}, grid.row(id).element);
				}
			}, this);
		},

		_preUnpin: function(/*Controller*/ac) {
			// summary: determine if need to confirm action with user - this happens if no selections are pinned
			var confirmationRequired = _.every(this._gridRight.selection, function(value, id) {
				return !this[id];
			}, this._pins);
			if (confirmationRequired) {
				ac.m_action.confirmAction = MessageDialog.BUTTON_CLEAR;
			}
			return true;
		},

		_onUnpin: function(/*Controller*/ac) {
			// summary: remove current selections from selected store - if none selected, then remove all
			var ids = _.filter(this.getSelectedImageUrls(), function(id) {
				return this[id];
			}, this._pins);

			if (!ids.length) {
				ids = _.keys(this._pins);
			}

			_.each(ids, function(id) {
				var e = this._gridRight.row(id).element;
				if (e) {
					query(".iconImgPin", e).orphan();
				}

				delete this._pins[id];
				this.storeSelected.remove(id);
			}, this);
		},

		_onTags: function(/*Controller*/ac) {
			// summary: add/remove tags to/from selected images (does not include pinned nodes)
			const item = this._paneItem;
			var add = ac.actionValue.add;
			var remove = ac.actionValue.remove;
			var nodes = ac.actionWidget.get("selection");
			var urls = _.pluck(nodes, "$URL");

			ac.m_writer.callMethod("SiteAdmin", "UpdateImageTags")
				.addParameter("URLs", xml.ATTR_REFVECTOR, urls)
				.addParameter("TagsToAdd", xml.ATTR_STRINGVECTOR, add)
				.addParameter("TagsToRemove", xml.ATTR_STRINGVECTOR, remove);

			item.onChangeData();
		},

		_onViewToggle: function(/*Controller*/ac) {
			// summary: toggle between gallery view and list view
			var listView = ac.m_action.m_id == "ListView";

			$(this.domNode).toggleClass('csi-image-browser-listView', listView);
			this._setSortPos();

			this._gridRight.renderRow = lang.hitch(this, listView ? this._renderColumnImage : this._renderRowImage);
			this._gridRight.set('showHeader', listView);
			this._gridRight.refresh();
		},

		_onAddToLibrary: function(/*Controller*/ac) {
			// summary: add selected images to library store
			var obj = {};

			_.each(this.getSelectedImages(), function(image, i) {
				try {
					_storeLibrary.add(image);
					obj[i + 1] = image.$URL;
				} catch (ex) {
					// ignore if image is already in library
				}
			});

			if (!_.isEmpty(obj)) {
				ac.m_writer.changeNode(_storeLibrary.nodeUrl).changeAttributeKeys(_storeLibrary.nodeAttribute, xml.ATTR_REFVECTOR, obj, true);
			}
		},

		_onDelete: function(/*Controller*/ac) {
			// summary: remove selected images from store (either uploads or library)
			var pins = this._pins;
			var s = this._gridRight.store;
			var isLibrary = (s == _storeLibrary);
			var ss = this.storeSelected;
			var urls = this.getSelectedImageUrls();

			if (isLibrary) {
				ac.m_writer.changeNode(_storeLibrary.nodeUrl).changeAttribute(_storeLibrary.nodeAttribute, xml.ATTR_REFVECTOR, urls, false, true);
			}

			urls.forEach((url) => {
				if (pins[url]) {
					delete pins[url];
					ss.remove(url);
				}
				if (!isLibrary) {
					ac.m_writer.changeNode(url).changeAttribute("UploadedByUser", xml.ATTR_REF, csi.EMPTY_URL);
				}

				s.remove(url);
			});
			this.syncImageStores(urls);
		},

		_renderCellHeader: function(obj, heading) {
			// summary: renderer for cells
			var id = obj.$URL;
			var div = html.create("div");
			var ctx = this.getContext(id);
			ctx.setReadOnly(true);
			ctx.applyNodeContext(div);
			csiHeading.toHtml(ctx, heading, html.create("div", null, div));
			return div;
		},

		_renderPinSelection: function(obj, div) {
			// summary: image cell pin selection renderer
			var id = obj.$URL;
			if (!this.isViewingSelections() && this._pins[id]) {
				html.create("div", {"class": "csiActionIcon iconImgPin"}, div);
			}

			if (this._preselects[id]) {
				delete this._preselects[id];
				// selects the newly uploaded images
				_.defer(function(grid, id) {
					grid.select(id);
				}, this._gridRight, id);
			}
			return div;
		},

		_renderCellDateAdded: function(obj, options) {
			// summary: render date cell
			return this._renderCellHeader(obj, this._dateSpec.heading);
		},

		_renderCellImageSize: function(obj, options) {
			// summary: render image file size in human readable format
			return this._renderCellHeader(obj, this._fileSizeSpec.heading);
		},

		_renderCellName: function(obj, options) {
			// summary: render File name
			return this._renderCellHeader(obj, this._imageNameSpec.heading);
		},

		_renderRowImage: function(obj, options) {
			// summary: render image cells for gallery view
			var dom = this._renderCellHeader(obj, this._thumbnailSpec.heading);
			return this._renderPinSelection(obj, dom);
		},

		_renderColumnImage: function(obj, options) {
			// summary: render image cells for list view
			var dom = html.create("div", {className: 'csi-image-browser-list-row'});
			dom = this._renderPinSelection(obj, dom);
			dom.appendChild(Grid.prototype.renderRow.apply(this._gridRight, arguments));
			return dom;
		},

		_setGallerySortOption: function(e) {
			// sync sort options on gallery view sort dropdown
			var option = e.sort[0];
			if (!option.descending) {
				option.descending = undefined;
			}
			this.sortPlugin.setOption(option);
		},

		_setNodeContextAttr: function(/*Node?*/node) {
			// summary: refresh Item store - even if context stays the same so that we get latest results
			var item = this._storeLeft.get("Item");
			var bItem = (this._gridRight.store == item.get("store"));
			var bChangeItem = xml.nodeGetURL(node) != xml.nodeGetURL(this.nodeContext);
			var store = node ? imageBase.getNodeImageStore(node) : null;

			this.preActionSetNode();
			item.set("store", store);

			this._bItemContext = !!store;
			this._set("nodeContext", node);
			this._updateVisibility();

			// if context has changed, then reset filter values
			if (bChangeItem) {
				item.onChangeData();
				item.set("query", {});
			}

			// if already on Item pane, then either refresh if new store, or switch to next pane if no store
			if (bItem) {
				this.selectFirstPane();
			}
		},

		_setBAllowSelectionAttr: function(/*boolean*/value) {
			this._set("bAllowSelection", value);
			this._updateVisibility();
		},

		_setSelectionModeAttr: function(/*String*/mode) {
			// summary: update view based on selection mode
			var bMultiple = (mode != "single");

			this._set("selectionMode", mode);
			this._gridRight.set("selectionMode", mode);
			this._updateVisibility();

			// if viewing selections pane and it is no longer visible, then switch to first pane
			if (!bMultiple && this.isViewingSelections()) {
				this.selectFirstPane();
			}
		},

		_setSortPos: function() {
			//summary: adds top position to sort by date option can be placed appropriately
			var top = SORT_TOP;
			var filterContainer = $(this.toolbarNode.domNode).find('.csi-filter-container');
			var filterHeight = filterContainer.get(0).offsetHeight;

			if (filterHeight) {
				top += filterHeight + parseInt(filterContainer.css('margin-top'));
			}

			$(this.toolbarNode.domNode).find('.csi-toolbar-btn-SortImages').css({top: top + "px"});
		},

		_updateVisibility: function() {
			// summary: set visibility of toolbar plugins based on settings
			var bMultiple = (this.selectionMode != "single");
			var bLibrary = !this.nodeContext;
			var grid = this._gridLeft;
			var store = this._storeLeft;
			var tb = this.toolbarNode;

			var pane = function(s, b) {
				var item = store.get(s);
				if (item) {
					html.setVisible(grid.row(item).element, b);
				}
			};

			var plugin = function(s, b) {
				// function hides the plugin from view if b is false and displays it if b is true
				var pluginObj = tb.getPlugin(s);

				if (pluginObj && pluginObj.domNode) {
					domClass.toggle(pluginObj.domNode, html.CSS_HIDE, !b);
				}
			};

			// allow Pin, Unpin if can select multiple images and not managing library
			plugin("Pin", bMultiple && !bLibrary);
			plugin("Unpin", bMultiple && !bLibrary);

			// use appropriate upload plugin based on selectionMode
			plugin("Upload", bMultiple);
			plugin("UploadOne", !bMultiple);

			// allow adding to library only when managing library - not when selecting images for node in context
			plugin("ImageBrowserAddToLibrary", bLibrary);

			// hide panes just for supplier
			const bShowPanes = !(sessionConstants.isLocalUser || this.browserFilter);

			// hide Item pane if no context
			pane("Item", this._bItemContext && bShowPanes);
			pane("Library", bShowPanes);
			pane("Site", bShowPanes);
			pane("Type", bShowPanes);
			// allow Selections pane if can select multiple images and not managing library
			pane("Selected", (bMultiple && !bLibrary) && bShowPanes);
			pane(THREED_TEXTURE, !!this.browserFilter);

			// hide dialog actions (Save, Cancel) if managing library
			html.setVisible(this.domNode.nextSibling, !bLibrary || this.bAllowSelection);
		}
	});

	var _Dialog = declare(Dialog, {
		dialogActions: true,

		// Boolean: force action buttons to be visible if true
		//bAllowSelection: false,

		// _Browser: image browser view
		//view: null,

		buildRendering: function() {
			// summary: add browser view to dialog
			this.inherited(arguments);

			domClass.add(this.domNode, "csi-image-browser");

			var pathHints = configPreferences.addContextualPathHints(null, [
				"(Image)Parent:Images(ImageContainer)"
			]);

			var defView = lang.mixin(new GalleryView(), {
				m_id: "ImageBrowser",
				m_typeView: "Gallery",
				m_headings: [
					lang.mixin(new Heading(), {m_id: reflection.ATTR_THUMBNAIL, classRendererParams: {globalContext: true}}),
					lang.mixin(new Heading(), {m_id: reflection.ATTR_TAGS}),
					lang.mixin(new Heading(), {m_id: xml.ATTR_NAME, m_name: "File"}),
					lang.mixin(new Heading(), {m_id: xml.ATTR_NAME, m_path: "Parent:Images", m_name: "Name"}),
					lang.mixin(new Heading(), {m_id: "ModifiedAt", m_name: "DateAdded"}),
					lang.mixin(new Heading(), {m_id: "FileSize", classRenderer: FileSizeRenderer}),
					lang.mixin(new Heading(), {m_id: "sortedIndex"})
				],
				m_relationship: lang.mixin(new Relationship(), {
					pathHintsContext: pathHints,
					m_typeNode: reflection.TYPE_IMAGE
				}),
				defToolbar: lang.mixin(new Toolbar(), {
					m_actions: [
						lang.mixin(new Action(), {
							classController: NewFileControllerForImages,
							classToolbarPlugin: ToolbarPluginFile,
							m_id: "Upload",
							m_class: "iconUpload",
							m_preAction: "_preUpload",
							m_postAction: "_onUpload",
							m_typeControl: def.ACTION_ICON
						}),
						lang.mixin(new Action(), {
							classController: _NewFileUploadController,
							classToolbarPlugin: _ToolbarPluginOneFile,
							m_id: "UploadOne",
							m_class: "iconUpload",
							m_preAction: "_preUpload",
							m_postAction: "_onUpload",
							m_typeControl: def.ACTION_ICON
						}),
						lang.mixin(new Action(), {
							materialIcon: "library_add",
							m_id: "ImageBrowserAddToLibrary",
							m_accessAction: "_canAddToLibrary",
							m_onAction: "_onAddToLibrary",
							m_typeControl: def.ACTION_ICON

						}),
						lang.mixin(new Action(), {
							materialIcon: "refresh",
							m_id: "Refresh",
							m_accessAction: "_canRefresh",
							m_onAction: "_onRefresh",
							m_typeControl: def.ACTION_ICON
						}),
						lang.mixin(new Action(), {
							materialIcon: "close",
							m_id: "Remove",
							m_accessAction: "_canDelete",
							m_onAction: "_onDelete",
							m_typeControl: def.ACTION_ICON
						}),
						lang.mixin(new Action(), {
							m_id: "Pin",
							m_class: "iconPin",
							m_accessAction: "_canPin",
							m_postAction: "_onPin",
							m_typeControl: def.ACTION_ICON
						}),
						lang.mixin(new Action(), {
							m_id: "Unpin",
							m_class: "iconUnpin",
							m_accessAction: "_canUnpin",
							m_preAction: "_preUnpin",
							m_postAction: "_onUnpin",
							m_typeControl: def.ACTION_ICON
						}),
						"|",
						lang.mixin(new Action(), {
							m_id: "Filter",
							m_onAction: "_onFilter",
							classToolbarPlugin: _FilterPlugin
						}),
						lang.mixin(new Action(), {
							classToolbarPlugin: _TagsPlugin,
							m_id: "Tags",
							m_accessAction: "_canTag",
							m_onAction: "_onTags"
						}),
						lang.mixin(new Action(), {
							classToolbarPlugin: ToolbarPluginRadioButton,
							classToolbarPluginParams: {
								radioClass: "csi-image-browser-view-toggle",
								"class": "csi-toolbar-radio-button csi-toggle-group-last csi-button-toggle"
							},
							materialIcon: "view_list",
							m_id: "ListView",
							m_onAction: "_onViewToggle",
							m_typeControl: def.ACTION_ICON
						}),
						lang.mixin(new Action(), {
							classToolbarPlugin: ToolbarPluginRadioButton,
							classToolbarPluginParams: {
								radioClass: "csi-image-browser-view-toggle",
								"class": "csi-toolbar-radio-button csi-toggle-group-first csi-button-toggle"
							},
							materialIcon: "view_module",
							m_id: "GalleryView",
							m_onAction: "_onViewToggle",
							m_bToggle: true,
							m_typeControl: def.ACTION_ICON
						}),
						lang.mixin(new Action(), {
							m_id: "SortImages",
							m_onAction: "_onSortImages",
							classToolbarPlugin: _SortImagesPlugin
						})
					]
				}),
				classController: _Browser
			});

			// the selected store does not use a caching store because we don't want to remove the image
			// from the cache if removing it from the selected store. We could potentially change the caching
			// wrapper's implementation, but for now just handle syncing the nodes manually (only place this
			// affects is tagging I believe)
			this.storeSelected = Observable(new Memory({idProperty: "$URL"}));

			this.view = csiView.newView(defView, null, {
				cacheView: _imageCacheStore,
				storeSelected: this.storeSelected
			});

			this.addChild(this.view);
		},

		onHide: function() {
			// summary: clear selections when dialog is hidden
			this.view.toggleDnD(false);
			this.view.resetSelections();
			this.inherited(arguments);
		},

		onShow: function() {
			// summary: select the first pane the first time dialog is shown - after that the current selection should be kept
			this.view.selectFirstPane(true);
			this.resize();
			this.inherited(arguments);
			// reset the store so it pickup any new changes on the store
			this.view.resetStore();
			this.view.toggleDnD(true);
		},

		resize: function() {
			// summary: calculate new size for dialog - keep minimum width for dialog so toolbar does not have to wrap
			var vp = winUtils.getBox();

			domStyle.set(this.view.domNode, {
				height: (this.maxRatio * vp.h - 100) + "px",
				width: (this.maxRatio * vp.w - 100) + "px"
			});

			this.inherited(arguments);
		},

		_getValueAttr: function() {
			// summary: return list of selected image nodes as value
			return this.storeSelected.query();
		},

		_setNodeContextAttr: function(/*Node*/node) {
			// summary: pass setting on to browser view
			this.view.set("nodeContext", node);
			this.closeButtonNode.setAttribute("title", locale.resource(node ? "Cancel" : "Close"));
		},

		_setBAllowSelectionAttr: function(/*boolean*/value) {
			// summary: pass setting on to browser view
			this.view.set("bAllowSelection", value);
		},

		_setSelectionModeAttr: function(/*String*/mode) {
			// summary: pass setting on to browser view
			this.view.set("selectionMode", mode);
		}
	});

	topic.subscribe("/csi/image/tag", function(url, tags) {
		var node = _imageCacheStore.getNode(url);
		if (node) {
			node.Tags = tags;
		}
	});

	return {
		dialog: function(/*Object?*/params) {
			// summary: return singleton instance of browser dialog
			if (!_dialog) {
				_dialog = new _Dialog(params);
				_dialog.startup();
			}

			return _dialog;
		}
	};
});
